import { useLocation, useNavigate } from "react-router-dom";
import AnimatedPage from "./animatedPage"
import Banner from "./banner/banner"
import { useMemo, useState } from "react";
import TabHeaders from "./campusLife/tabHeaders";
import Contents from "./campusLife/tabContents";

const TabsPage = ({ title, bg, data }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultActiveTab = parseInt(queryParams.get('tab')) || 0;
    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    const handleTabClick = (index) => {
        setActiveTab(index);
        queryParams.set('tab', index);
        navigate({ search: queryParams.toString() });
    };




    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <div className="flex justify-center w-full p-8 md:p-12">
                <div className="w-full lg:max-w-7xl">
                    <div className="w-full relative  flex flex-col ">
                        <div className="flex w-full bg-cover bg-no-repeat bg-center pt-4 rounded-lg" style={{ backgroundImage: `url(${bg})` }} >

                            <TabHeaders headers={data?.map(item => item.header)} activeTab={activeTab} handleTabClick={handleTabClick} />
                        </div>
                        <Contents contents={data?.map(tab => tab.content)} activeTab={activeTab} />
                    </div>

                </div>

            </div>
        </AnimatedPage>
    )
}

export default TabsPage